import { useCallback } from 'react';
import { useViewTransition } from './useViewTransition';

/**
 * Хук для "назад"-навигации с анимацией в обратном направлении.
 */
export function useBackNavigation() {
  const navigate = useViewTransition();

  return useCallback(() => {
    // Помечаем корень — CSS подцепит реверс-анимацию
    document.documentElement.setAttribute('data-back', 'true');
    navigate(-1);
    // Сбрасываем атрибут после завершения перехода
    setTimeout(() => {
      document.documentElement.removeAttribute('data-back');
    }, 400);
  }, [navigate]);
}